import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Palette = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M13.4 2.096a10.08 10.08 0 00-8.937 3.331A10.054 10.054 0 002.096 13.4c.53 3.894 3.458 7.207 7.285 8.246a9.982 9.982 0 002.618.354l.142-.001a3.001 3.001 0 002.516-1.426 2.989 2.989 0 00.153-2.879l-.199-.416a1.919 1.919 0 01.094-1.912 2.004 2.004 0 012.576-.755l.412.197c.412.198.85.299 1.301.299A3.022 3.022 0 0022 12.14a9.935 9.935 0 00-.353-2.76c-1.04-3.826-4.353-6.754-8.247-7.284zm5.158 10.909l-.412-.197c-1.828-.878-4.07-.198-5.135 1.494-.738 1.176-.813 2.576-.204 3.842l.199.416a.983.983 0 01-.051.961.992.992 0 01-.844.479h-.112a8.061 8.061 0 01-2.095-.283c-3.063-.831-5.403-3.479-5.826-6.586-.321-2.355.352-4.623 1.893-6.389a8.002 8.002 0 017.16-2.664c3.107.423 5.755 2.764 6.586 5.826.198.73.293 1.474.282 2.207-.012.807-.845 1.183-1.441.894z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 7.5,
    cy: 14.5,
    r: 1.5,
    key: "k1"
  }), React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 1.5,
    key: "k2"
  }), React.createElement("circle", {
    cx: 10.5,
    cy: 7.5,
    r: 1.5,
    key: "k3"
  }), React.createElement("circle", {
    cx: 14.5,
    cy: 7.5,
    r: 1.5,
    key: "k4"
  }));
});
Palette.displayName = 'Palette';
export var PaletteDimensions = {
  height: 24,
  width: 24
};